/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListModuleLecturerResponseData } from './genericApiResponseListModuleLecturerResponseData';
import type { GenericApiResponseListModuleLecturerResponseMessage } from './genericApiResponseListModuleLecturerResponseMessage';
import type { GenericApiResponseListModuleLecturerResponsePagination } from './genericApiResponseListModuleLecturerResponsePagination';
import type { GenericApiResponseListModuleLecturerResponseError } from './genericApiResponseListModuleLecturerResponseError';

export interface GenericApiResponseListModuleLecturerResponse {
  data?: GenericApiResponseListModuleLecturerResponseData;
  message?: GenericApiResponseListModuleLecturerResponseMessage;
  pagination?: GenericApiResponseListModuleLecturerResponsePagination;
  error?: GenericApiResponseListModuleLecturerResponseError;
  statusCode?: number;
}
